import { useEffect, useState } from "react";

import { EmployeeService } from "~/entity/Employee/api/service";
import { EmployeeExpectation } from "~/entity/Employee/model/schema";

export const useEmployeeExpectations = () => {
  const [expectations, setExpectations] = useState<EmployeeExpectation[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;

    setLoading(true);
    EmployeeService.GET.expectations()
      .then((response) => {
        if (!cancelled) {
          setExpectations(response.data.expectations || []);
        }
      })
      .catch((error) => {
        console.error("Ошибка загрузки должностей:", error);
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { expectations, loading };
};
